import React, { useEffect, useCallback, useState } from 'react'
import { Divider, Typography, Spin, message } from 'antd'
import { DndProvider } from 'react-dnd'
import CarouselItem from './carousel-item'
import Carousel from './carousel'
import { HTML5Backend } from 'react-dnd-html5-backend'
import useForceRender from 'src/utils/ForceRender'
import { clone } from 'ramda'
import * as api from 'src/api/metaverse'
import s from './index.module.scss'
import AddingModal from './addItems-modal'
import ProviderCountrySelect from 'src/components/Input/ProviderCountrySelect'

const { Title } = Typography

const MainDiscovery: React.FC = () => {
  const forceRender = useForceRender()
  const selectedMetaverse = React.useRef<Metaverse>(null)
  const showAdding = React.useRef<boolean>(false)
  const loading = React.useRef<boolean>(true)
  const data = React.useRef<any[]>([])
  const [providerCountry, setProviderCountry] = useState<string | null>('TN')

  const loadPageData = useCallback(async (country?: string | null) => {
    try {
      loading.current = true
      forceRender()
      const discovery = await api.getMainDiscovery(country ?? undefined)

      data.current = discovery
    } finally {
      loading.current = false
      forceRender()
    }
  }, [])

  useEffect(() => {
    loadPageData(providerCountry)
  }, [loadPageData, providerCountry])

  const onModalCancel = React.useCallback(() => {
    selectedMetaverse.current = null
    showAdding.current = false
    forceRender()
  }, [])

  const onAddClick = React.useCallback((category: MetaverseRoomCategory) => {
    selectedMetaverse.current = category
    showAdding.current = true
    forceRender()
  }, [])

  const onModalDone = React.useCallback(() => {
    onModalCancel()
   
  loadPageData(providerCountry)
  }, [onModalCancel, loadPageData, providerCountry])

   const handleCountryChange = (countriesList: string[]) => {
    
    const next = countriesList?.[0] ?? null
    setProviderCountry(next)
    
  }
  const updateOrdering = React.useCallback(
    async (dragId: string, dropId: string, category: MetaverseRoomCategory) => {
      const categoryNew = data.current.find((cat: MetaverseRoomCategory) => cat.id === category.id) as MetaverseRoomCategory;

      const dragIndex = categoryNew.rooms.findIndex((i) => i.id === dragId);
      const dropIdIndex = categoryNew.rooms.findIndex((i) => i.id === dropId);

      let dropIndex: number;

      if (dropIdIndex === 0) {
        
        
        dropIndex = dropIdIndex;
      } else if (dragIndex > dropIdIndex) {
      
        dropIndex = dropIdIndex;
      } else {
        
        dropIndex = dropIdIndex+1;
      }
      
      const drapItem = categoryNew.rooms[dragIndex];
      const tempItem = { id: 'temp' } as any;
      const cloneItems = [...categoryNew.rooms];
      cloneItems[dragIndex] = tempItem;
      cloneItems.splice(dropIndex, 0, drapItem);
      const orderedItems = cloneItems.filter((i) => i.id !== 'temp');
  
      // Update sort indexes based on category type
      orderedItems.forEach((item, index) => {
        if (category.id === 'MUSIC') {
          
          item.musicSortIndex = index+1;
        } else if (category.id === 'COUNTRIES') {
          item.countrySortIndex = index+1;
        }    else if (category.id === 'TWINS') {
          item.twinSortIndex = index+1;
        } 
        
      });
  
      // Update the category with the ordered items
      const updatedCategory = {
        ...categoryNew,
        rooms: orderedItems,
      };
  
      loading.current = true;
      forceRender();
      await api.updateMetaverseOrder(categoryNew.id, updatedCategory);
      message.success(`Updated metaverse ordering of ${categoryNew.type}`);
      loadPageData();
    },
    [data]
  );
  const handleRemoving = React.useCallback(
      async (item: MainDiscovery) => {
        loading.current = true
        forceRender()
        await api.deleteFromMainDiscovery(providerCountry,item.entityId)
        message.success(`${item?.type ==='METAVERSE'|| item?.type === 'EVENT'? item.name:item.title} is removed`)
        loadPageData(providerCountry)
      },
      [providerCountry]
    )

  return (
    <Spin spinning={loading.current}>
      <Title level={3}>Main</Title>
      <Divider />
      <DndProvider backend={HTML5Backend}>
        <ProviderCountrySelect  value={providerCountry ? [providerCountry] : []}
 includeAllOption={false} onChange={handleCountryChange} />
        {data.current?.map((category) => (
          <Carousel
            key={category.id}
            name={category.type}
            onAddClick={() => onAddClick(category)}
          >
            {category.Main?.length ? (
              category.Main.map((item) => (
                <CarouselItem
                  key={item.id} 
                  metaverse={item}
                  categoryId={category.id}
                
                  onRemove={(metaverse) => handleRemoving(metaverse)}
                />
              ))
            ) : (
              <span className={s.noData}> No data</span>
            )}
          </Carousel>
        ))}
      </DndProvider>
      <AddingModal
             visible={showAdding.current}
             category={selectedMetaverse.current}
             onDone={onModalDone}
             onCancel={onModalCancel}
             defaultProviderCountry={providerCountry}
           />
    </Spin>
  )
}

MainDiscovery.displayName = 'Discovery'

export default MainDiscovery
